export class AssetHyperlinkModel {
    id: string = "";
    name: string = "";
    hyperlinkUrl: string = "";
    hyperlinkType?: string = null;
    description?: string = "";
}